import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Card } from '@mui/material'

// import { Logger, LoggerTypes } from '../../../utils'
import './style.scss'

/**
 * Format a timestamp string date format into a calendar style date block.
 *
 * @param {string} date String date to format, Ex: 2022-12-31T13:55:00
 * @param {string} className CSS class name to apply.
 * @returns {Card}
 */
export const DateCard = ({ date, className }) => {
  const _date = moment(date)

  // Logger.trace(LoggerTypes.CONTAINER, 'DateCard.render()', { date, _date })

  return (
    <Card className={`DateCard ${className}`}>
      <span className="month">{_date.format('MM')}</span>
      <span className="day">{_date.format('DD')}</span>
      <span className="year">{_date.format('YYYY')}</span>
    </Card>
  )
}

DateCard.displayName = 'DateCard'

DateCard.propTypes = {
  date: PropTypes.string.isRequired,
  className: PropTypes.string
}

DateCard.defaultProps = {
  date: null,
  className: ''
}
